<template>
    <div class="story-maker-sticker-menu-link">
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.link-title') }}</p>
        </div>
        <div class="content">
            
            <div class="form">
                <div class="container-input">
                    <div class="input input-link">
                        <i class="fa-regular fa-link"></i>
                        <input :placeholder="$t('dash.post-creator.story.url-placeholder')" v-model="models.link">
                    </div>
                    <div class="url-length-info">
                        <p class="url-length-warning" v-if="isOverLimit">{{ $t('dash.post-creator.story.link-url-too-long') }}</p>
                        <p class="url-length-info-bitly" v-else-if="hasBitlyToken && models.link.length > 245">{{ $t('dash.post-creator.story.link-url-bitly') }}</p>
                        <span class="url-length-count" :class="{ 'at-limit': isOverLimit }">{{ models.link.length }}/245</span>
                    </div>
                    <p class="error">{{ error }}</p>
                </div>

                <!-- Raccourcisseur mws.li actif pour le compte : lien court visible dans le sticker, texte du sticker
                     pré-rempli avec le domaine d'origine (sinon Instagram afficherait « MWS.LI ») -->
                <p v-if="shortLinksActive && canShorten" class="shorten-link" :class="{ disable: shortening }" @click="shortenLink">
                    <i class="fa-solid" :class="shortening ? 'fa-spinner fa-spin' : 'fa-link'"></i> {{ $t('dash.post-creator.story.link-shorten') }}
                </p>
                <p v-if="shortenedFrom" class="shortened-info">{{ $t('dash.post-creator.story.link-shortened', { domain: shortenedFrom }) }}</p>

                <p v-if="!showEditText" @click="toggleDisplayAddText" class="add-text"><i class="fa-solid fa-plus"></i> {{ $t('dash.post-creator.story.link-add-text') }}</p>
                <p v-else="" @click="toggleDisplayAddText" class="add-text">{{ $t('dash.post-creator.story.link-remove-text') }}</p>
                
                <div v-if="showEditText" class="container-input">
                    <div class="input input-text">
                        <input :placeholder="$t('dash.post-creator.story.link-sticker-text-placeholder')" v-model="models.text">
                    </div>
                </div>

            </div>

            <div class="button" :class="{ disable: isOverLimit }" @click="finish">
                {{ $t('dash.post-creator.story.add-button') }}
            </div>
        </div>
        
    </div>
</template>


<script>
import ShortLinksMixin from '@/components/mixins/ShortLinks.vue'
import { composerShortenerEnabled, createComposerShortLink, isShortLinkUrl, isHttpUrl, stickerDomainLabel } from '@/utils/composerShortLinks'

const { VUE_APP_API_HOST } = process.env

export default {
    mixins: [ShortLinksMixin],

    data() {
        return {
            models: {
                link : '',
                text: '',
            },
            showEditText : false,
            error : '',
            hasBitlyToken: false,
            // raccourcisseur mws.li actif pour le compte (beta + réglage activé)
            shortLinksActive: false,
            shortening: false,
            // domaine d'origine du lien raccourci ici (texte du sticker), null sinon
            shortenedFrom: null,
            shortUrl: null,
        }
    },

    computed: {
        isOverLimit() {
            return this.models.link.length > 245 && !this.hasBitlyToken;
        },
        // Lien http(s) valide, pas déjà sur le domaine court
        canShorten() {
            const link = (this.models.link || '').trim()
            return !!link && isHttpUrl(link) && !isShortLinkUrl(link)
        }
    },

    watch: {
        // Lien modifié après raccourcissement : ce n'est plus le lien court créé ici
        'models.link'(value) {
            if (this.shortUrl && value !== this.shortUrl) {
                this.shortUrl = null
                this.shortenedFrom = null
            }
        }
    },

    created() {
        composerShortenerEnabled().then(enabled => { this.shortLinksActive = enabled })
    },

    async mounted() {
        try {
            const user = JSON.parse(localStorage.user);
            const res = await this.$http.get(`${VUE_APP_API_HOST}/accounts/${user.account}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            this.hasBitlyToken = !!(res.body && res.body.account && res.body.account.bitly_token);
        } catch(e) {
            // silently fail — limit stays enforced
        }
    },

    methods: {
        // Lien générique mws.li (re-décliné par page à la publication) ; texte du sticker = domaine d'origine si vide
        async shortenLink() {
            if (this.shortening || !this.canShorten) return
            const original = this.models.link.trim()
            this.shortening = true
            this.error = ''
            try {
                const link = await createComposerShortLink(original)
                const label = stickerDomainLabel(original)
                this.shortUrl = link.short_url
                this.models.link = link.short_url
                this.shortenedFrom = label
                if (!this.models.text && label) {
                    this.showEditText = true
                    this.models.text = label
                }
            } catch (res) {
                this.error = this.shortLinkErrorMessage(res)
            } finally {
                this.shortening = false
            }
        },

        finish() {
            if (this.isOverLimit) return
            this.error = ''
            this.models.link = this.models.link.trim();
            console.log('validURL', this.models.link, this.validURL(this.models.link))
            if (!this.validURL(this.models.link)){
                this.error = 'adresse invalide'
                return
            }
           
            this.$emit('addSticker','link', {
                data: {
                    ...this.models,
                    styleVariant: 1
                }
            })
        },

        validURL(str) {
            if(str == '') return true
            try {
                return Boolean(new URL(str)); 
            }
            catch(e){ 
                return false; 
            }
        },

        toggleDisplayAddText() {

            this.showEditText = !this.showEditText
            this.models.text = ''
        }
    },
}
</script>

<style lang="scss" scoped>

</style>